import { useState, useEffect } from 'react'
import { getFillValue } from '../helpers/getFillValue';

export const useGetFillValue = ( legendData, variableName, variableValue ) => {

    const [chartProps, setChartProps] = useState('');
    
    useEffect( () => {
        setChartProps(getFillValue( legendData, variableName, variableValue ));
    }, [legendData, variableName, variableValue])
    return chartProps;
}